import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISelectableOrgsState, SelectableOrgsStoreService } from '../../services/store/selectable-orgs-store.service';
import { SelectedOrgService } from '../../services/selected-org.service';
import { Subscription, finalize, take } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { NavigationService } from '../../services/navigation.service';
import { DropdownModule } from 'primeng/dropdown';
import { UserStoreService } from '../../services/store/user-store.service';
import { TranslateModule } from '@ngx-translate/core';
import { IOrganization } from '../../models/organization/organization.model';
import { OrganizationsService } from '../../services/entities/organizations/organizations.service';
import { RoleType } from '../../enums/user/role-types.enum';

@Component({
  selector: 'app-selectable-orgs-dropdown',
  standalone: true,
  imports: [
    CommonModule, FormsModule,
    DropdownModule, TranslateModule
  ],
  templateUrl: './selectable-orgs-dropdown.component.html',
  styleUrls: ['./selectable-orgs-dropdown.component.scss']
})
export class SelectableOrgsDropdownComponent implements OnInit, OnDestroy {

  state: ISelectableOrgsState | undefined;

  selectedOrgId: number | null = null;

  orgsOptions: (IOrganization | { id: number; legalName: string; })[] = [];

  orgsSub: Subscription = Subscription.EMPTY;
  selectedOrgSub: Subscription = Subscription.EMPTY;

  CREATE_NEW_ORG_ID = -69;

  constructor(
    private selectableOrgsStore: SelectableOrgsStoreService,
    private selectedOrgService: SelectedOrgService,
    private navService: NavigationService,
    private userStore: UserStoreService,
    private orgService: OrganizationsService
  ) {
  }

  ngOnInit(): void {
    this.state = this.selectableOrgsStore.getState();

    this.orgsSub = this.state.orgs$.subscribe((orgs) => {
      const user = this.userStore.state.user$.getValue();
      this.orgsOptions = [...orgs];
      if (user?.roles.find((role) => role.type === RoleType.SYSTEM_ADMIN)) {
        this.orgsOptions.unshift({ id: this.CREATE_NEW_ORG_ID, legalName: 'admin.shared.selectable-orgs-dropdown.create-new-organization' });
      }
    });

    this.selectedOrgSub = this.selectedOrgService.selectedOrgId$.subscribe(orgId => {
      this.selectedOrgId = orgId;
    });
  }

  async onSelect(e: { originalEvent: Event, value: number }) {
    if (e.value === this.CREATE_NEW_ORG_ID) {
      this.orgService.createOrganization().pipe(
        take(1),
        finalize(() => {})
      ).subscribe(async (newOrg) => {
        // console.log(newOrg);
        this.selectableOrgsStore.init();
        const user = this.userStore.state.user$.getValue();
        await this.navService.goToLoadingPage();
        this.selectedOrgService.setOrgId(newOrg.id, false);
        // console.log(user);
        if (user) await this.navService.goToUsersDashboard(user, newOrg.id);
        await this.navService.reloadRoute();
      });
    } else {
      const user = this.userStore.state.user$.getValue();
      await this.navService.goToLoadingPage(); // here bcs of there has to be some kind of 'delay' - we need to hide all components that work with orgUsers, bcs there will be short moment when functions will not find anything in orgUsers
      this.selectedOrgService.setOrgId(e.value, false);
      if (user) await this.navService.goToUsersDashboard(user, e.value);
      await this.navService.reloadRoute();
    }
  }

  ngOnDestroy(): void {
    this.selectedOrgSub.unsubscribe();
    this.orgsSub.unsubscribe();
  }
}
